var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',[_c('SectionCompaniesInnerPages',{attrs:{"article-length":_vm.articleLength,"limit-side-banners":_vm.limitSideBanners}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }